import React, { useEffect, useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Clock from 'react-clock';
import Logo from '../../assets/logo-eabc.png';
import backgroundImage from "../../assets/logo-eabc.png";
import 'react-clock/dist/Clock.css';
import AuthContext from '../../Auth/AuthContext';
import authStorage from '../../Auth/Storage';
import { HandleAdminLogin } from '../../api/Auth';

function LoginForm() {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  const [date, setDate] = useState(new Date());
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setDate(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (!username.trim()) {
      setLoading(false);
      return setError("Email is required!");
    }
    if (!password.trim()) {
      setLoading(false);
      return setError("Password is required!");
    }

    const userData = { email: username, password };

    HandleAdminLogin(userData, (result) => {
      setLoading(false);
      if (result.ok === 1) {
        authStorage.storeUser(
          JSON.stringify({ username: result.username, rank: result.rank_, email: result.email })
        );
        authContext.setUser(result.username);

        if (result.rank_ === "Admin") {
          navigate("/");
        } else {
          navigate("/login");
          navigate(0);
        }
      } else {
        setError("Invalid credentials. Please try again.");
      }
    });
  };

  const currentTime = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });

  const currentDate = date.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10 col-xl-8">
            <div className="card border-0 shadow-lg" style={{ 
              borderRadius: '20px',
              overflow: 'hidden',
              backdropFilter: 'blur(10px)',
              background: 'rgba(255, 255, 255, 0.95)'
            }}>
              <div className="row g-0">
                {/* Left Side - Branding & Clock */}
                <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center p-4 p-md-5" style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}>
                  <div className="text-center mb-4">
                    <div className="bg-white bg-opacity-20 rounded-circle p-3 mb-3" style={{ width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="bi bi-building fs-1"></i>
                    </div>
                    <h3 className="fw-bold mb-2">EABC TRADERS</h3>
                    <p className="mb-0 opacity-75">Management System</p>
                  </div>

                  {/* Modern Clock Display */}
                  <div className="text-center mb-4">
                    <div className="bg-white bg-opacity-10 rounded-3 p-4 mb-3">
                      <div className="display-4 fw-bold mb-2" style={{ fontFamily: 'monospace' }}>
                        {currentTime}
                      </div>
                      <div className="small opacity-75">
                        {currentDate}
                      </div>
                    </div>
                  </div>

                  {/* Features List */}
                  <div className="d-none d-md-block">
                    <div className="small opacity-75">
                      <div className="d-flex align-items-center mb-2">
                        <i className="bi bi-check-circle me-2"></i>
                        Secure Authentication
                      </div>
                      <div className="d-flex align-items-center mb-2">
                        <i className="bi bi-check-circle me-2"></i>
                        Real-time Dashboard
                      </div>
                      <div className="d-flex align-items-center">
                        <i className="bi bi-check-circle me-2"></i>
                        Cross-border Trading
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Side - Login Form */}
                <div className="col-12 col-md-6 p-4 p-md-5">
                  <div className="text-center mb-4">
                    <img src={Logo} height="60" alt="EABC Logo" className="mb-3" />
                    <h4 className="fw-bold text-dark mb-2">Welcome Back</h4>
                    <p className="text-muted">Sign in to your account to continue</p>
                  </div>

                  <form onSubmit={handleLogin}>
                    {error && (
                      <div className="alert alert-danger border-0 rounded-3 d-flex align-items-center mb-4" role="alert">
                        <i className="bi bi-exclamation-triangle-fill me-2"></i>
                        {error}
                      </div>
                    )}

                    <div className="mb-3">
                      <label htmlFor="email" className="form-label fw-semibold text-dark">
                        <i className="bi bi-envelope me-2"></i>
                        Email Address
                      </label>
                      <input
                        type="email"
                        id="email"
                        className="form-control form-control-lg border-0 bg-light"
                        placeholder="Enter your email address"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        style={{ borderRadius: '12px', padding: '12px 16px' }}
                        required
                      />
                    </div>

                    <div className="mb-4">
                      <label htmlFor="password" className="form-label fw-semibold text-dark">
                        <i className="bi bi-lock me-2"></i>
                        Password
                      </label>
                      <div className="position-relative">
                        <input
                          type={showPassword ? "text" : "password"}
                          id="password"
                          className="form-control form-control-lg border-0 bg-light"
                          placeholder="Enter your password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          style={{ borderRadius: '12px', padding: '12px 16px', paddingRight: '50px' }}
                          required
                        />
                        <button
                          type="button"
                          className="btn btn-link position-absolute end-0 top-50 translate-middle-y me-2"
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ border: 'none', background: 'none' }}
                        >
                          <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'} text-muted`}></i>
                        </button>
                      </div>
                    </div>

                    <div className="d-grid mb-3">
                      <button
                        type="submit"
                        className="btn btn-lg text-white fw-semibold"
                        disabled={loading}
                        style={{
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          border: 'none',
                          borderRadius: '12px',
                          padding: '12px',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                          if (!loading) {
                            e.target.style.transform = 'translateY(-2px)';
                            e.target.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.3)';
                          }
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = 'translateY(0)';
                          e.target.style.boxShadow = 'none';
                        }}
                      >
                        {loading ? (
                          <>
                            <div className="spinner-border spinner-border-sm me-2" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                            Signing In...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-box-arrow-in-right me-2"></i>
                            Sign In to Dashboard
                          </>
                        )}
                      </button>
                    </div>

                    <div className="text-center">
                      <small className="text-muted">
                        <i className="bi bi-shield-check me-1"></i>
                        Your connection is secure and encrypted
                      </small>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Background Animation */}
      <style jsx>{`
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
          100% { transform: translateY(0px); }
        }
        
        .card {
          animation: float 6s ease-in-out infinite;
        }
        
        .form-control:focus {
          border-color: transparent;
          box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
          background-color: #fff;
        }
        
        .alert {
          animation: slideIn 0.3s ease-out;
        }
        
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}

export default LoginForm;